import React, { Component } from 'react';
import { API_ENDPOINT } from '../constants';
import { Player } from '@lottiefiles/react-lottie-player';

/**
* Payson MitID check component 
* @author   Stefan Pantic
*/
class MitID extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {
        let session = typeof window !== 'undefined' ? window.location.search.split('sessionId=')[1]?.split('&')[0] : null;

        if (window.location.search.includes('conversationId')) {
            let conversationId = window.location.search.split('conversationId=')[1]?.split('&')[0];
            fetch(API_ENDPOINT + '/users/mitID/get/video-link', {
                method: 'POST',
                headers: {
                    'content-type': 'application/json'
                },
                body: JSON.stringify({
                    sessionId: session,
                })
            }).then(res => res.json()).then((result) => {
                if (result.error) {
                    if (result.verifyCpr) {
                        this.props[0].history.push({
                            pathname: '/my-data/account',
                            state: { error: result.error }
                        })
                    } else {
                        this.props[0].history.push({
                            pathname: '/',
                            state: { error: result.error }
                        })
                    }

                } else if (result.link) {
                    if (window.location.search.includes('sessionStatus=Failed')) {
                        if (localStorage.getItem('groupAlias')) {
                            this.props[0].history.push({
                                pathname: `/${localStorage.getItem('groupAlias')}`,
                                state: {}
                            })
                        } else {
                            this.props[0].history.push({
                                pathname: `/`,
                                state: {}
                            })
                        }
                    } else {
                        this.props[0].history.push({
                            pathname: result.link,
                            state: { conversation: conversationId, key: result.key },
                            search: `?roomId=${result.link.split('roomId=')[1]}`
                        })
                    }

                }
            })

        } else if (session)
            this.logInMitID(session);


    }

    logInMitID = (session) => {
        fetch(API_ENDPOINT + '/users/mitID/check', {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                sessionId: session,
                alias: localStorage.getItem('groupAlias'),
            })
        }).then(res => res.json()).then((result) => {
            if (result.error) {
                if (localStorage.getItem('groupAlias') && localStorage.getItem('loginGroupAlias') !== 'noGroupAlias') {

                    this.props[0].history.push({
                        pathname: `/${localStorage.getItem('groupAlias')}`,
                        state: { mitIdError: result.error }
                    })
                } else {

                    this.props[0].history.push({
                        pathname: `/my-data/account`,
                        state: { mitIdError: result.error }
                    })
                }
            } else if (result.sessionId && result.token) {
                if (result.error) {
                    this.setState({
                        error: result.error
                    })
                } else {
                    try {
                        if (result?.userData && typeof window !== 'undefined') {
                            localStorage?.setItem?.('userData', JSON.stringify(result?.userData));
                        }
                    } catch (err) {
                        console.error('login user data err: ', err);
                    }
                    if (result.mitIdDataAfterRedirect.indexOf('doctorLogin') > -1) {
                        localStorage.setItem('authToken', result.token);
                        localStorage.setItem('time', Math.floor(Date.now() / 1000))
                        localStorage.setItem('profile', 'doctor');
                        localStorage.setItem('userLevel', 20);
                        localStorage.setItem('logoutLandingPage', true);
                        this.props.registerLog('Logged in');
                        this.props.verifyUser(() => {
                            this.props.registerClinicGroupLogs({
                                type: 'login',
                                loginType: 'username'
                            })
                            if (this.props.uData && this.props.uData.clinicGroups && this.props.uData.clinicGroups.length) {
                                let arr = [];
                                for (let i = 0; i < this.props.uData.clinicGroups.length; i++) {
                                    arr.push(this.props.uData.clinicGroups[i]);
                                }
                                localStorage.setItem('groupAlias', this.props.alias);
                            } else {
                                localStorage.setItem('groupAlias', this.props.alias);
                            }
                            if (this.props.uData && this.props.uData.userLevel) {
                                localStorage.setItem('userLevel', this.props.uData.userLevel);
                            }

                            localStorage.setItem('loginGroupAlias', this.props.alias);
                            this.props[0].history.push(`/`);
                        }, () => {
                            if (localStorage.getItem('loginGroupAlias') == localStorage.getItem('groupAlias') && this.state.data && localStorage.getItem('groupAlias') !== 'noGroupAlias') {
                                this.props.changeGroup(this.state.data?._id);
                            } else {
                                let arr = [];
                                if (this.props?.uData?.clinicGroups?.length) {
                                    for (let i = 0; i < this.props?.uData?.clinicGroups?.length; i++) {
                                        arr.push(this.props.uData.clinicGroups[i]);
                                    }
                                }
                                if (arr && arr.length > 0 && arr[0]) this.props.changeGroup(arr[0]?._id);
                            }

                        });
                    } else {
                        if (result.newUser) {
                            localStorage.setItem('newUserDataMitId', result.mitIdDataAfterRedirect)
                        }

                        if (result.sessionId) {
                            localStorage.setItem('sessionId', result.sessionId)
                        }

                        localStorage.setItem('authToken', result.token);
                        localStorage.setItem('time', Math.floor(Date.now() / 1000))
                        localStorage.setItem('profile', 'patient');


                        if (localStorage.getItem('groupAlias')) {
                            localStorage.setItem('logoutLandingPage', true);
                            localStorage.setItem('loginGroupAlias', localStorage.getItem('groupAlias'));
                        }
                        this.setState({
                            mitIdDataAfterRedirect: JSON.parse(result.mitIdDataAfterRedirect)
                        }, () => {
                            if (this.state.mitIdDataAfterRedirect) {

                                this.props[0].history.push({
                                    pathname: this.state.mitIdDataAfterRedirect?.redirectLink ?? '/my-data/account',
                                    state: {
                                        mitIdDataAfterRedirect: this.state.mitIdDataAfterRedirect,
                                        referral: this.state.mitIdDataAfterRedirect?.referral,
                                        selectedReferral: this.state.mitIdDataAfterRedirect?.selectedReferral,
                                        clinicGroup: this.state.mitIdDataAfterRedirect?.clinicGroup,
                                        isDropIn: this.state.mitIdDataAfterRedirect?.isDropIn,
                                        selectedDropInForm: this.state.mitIdDataAfterRedirect?.selectedDropInForm,
                                        tabIndex: this.state.mitIdDataAfterRedirect?.tabIndex,
                                    }
                                })
                            } else {
                                if (localStorage.getItem('groupAlias')) {
                                    this.props[0].history.push({
                                        pathname: `/${localStorage.getItem('groupAlias')}`,
                                        state: {}
                                    })
                                } else {
                                    this.props[0].history.push({
                                        pathname: `/`,
                                        state: {}
                                    })
                                }
                            }
                        })

                        this.props.verifyUser(() => { }, null, false, () => {
                            if (this.props.navigateToMyChildren && (this.props?.uData?.userLevel == 2 || (this.props?.uData?.userLevel == 20 && typeof window !== 'undefined' && localStorage?.getItem?.('profile') == 'patient'))) {

                                this.props?.[0]?.history?.push?.(
                                    '/my-data/account',
                                    { navigateToMyChildren: true }
                                );
                            };
                        });

                    }

                }
            } else {
                if (localStorage.getItem('groupAlias')) {
                    this.props.verifyUser(() => { }, null, false, () => {
                        this.props[0].history.push({
                            pathname: `/${localStorage.getItem('groupAlias')}`,
                            state: {}
                        })
                    })

                } else {
                    this.props.verifyUser(() => { }, null, false, () => {
                        this.props[0].history.push({
                            pathname: `/`,
                            state: {}
                        })
                    })
                }
            }
        })
    }

    render() {
        return (
            <div className='fullscreen-loader'>
                {
                    this.state.loading ?
                        <div className="loader-wrap" >
                            <Player
                                autoplay={true}
                                loop={true}
                                src="/lf30_editor_l5cxzdyf.json"
                                style={{ height: typeof window != 'undefined' && window.innerWidth < 768 ? "128px" : "256px", width: typeof window != 'undefined' && window.innerWidth < 768 ? "128px" : "256px" }}
                            ></Player>

                        </div>
                        :
                        null
                }

                {
                    this.props.lang && this.state.loading ?
                        <p>{"Checking...".translate(this.props.lang)}</p>
                        :
                        null
                }

            </div>




        );
    }
}

export default MitID;